import { ClipboardEvent } from 'react'

export const handleTrimValueOnPaste = (
  event: ClipboardEvent<HTMLDivElement>,
  fieldValue: string,
  setFieldValue: (field: string, value: any) => void,
  fieldName: string,
) => {
  event.preventDefault()

  const pastedText = event.clipboardData.getData('text').trim()

  const inputElement = event.target as HTMLInputElement
  const { selectionStart, selectionEnd } = inputElement

  // Insert the trimmed pasted text at the current cursor position
  const newValue =
    fieldValue.slice(0, selectionStart || 0) + pastedText + fieldValue.slice(selectionEnd || 0)

  setFieldValue(fieldName, newValue) // Update Formik's state with the new value
}
